import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import './Layout.css';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { instance, accounts } = useMsal();
  const location = useLocation();
  const user = accounts[0];

  const handleLogout = () => {
    instance.logoutPopup({
      postLogoutRedirectUri: '/',
    });
  };

  const isActive = (path: string) => location.pathname === path;

  return (
    <div className="ds-page layout-root" style={{ minHeight: '100vh', background: '#0B2C40' }}>
      {/* Header */}
      <header className="layout-header" style={{ background: 'white', borderBottom: '2px solid #0A2C40' }}>
        <div className="layout-header-container">
          <div className="layout-header-left">
            <Link to="/" className="layout-logo-link">
              <img 
                src="/logo192.png" 
                alt="askJoseph" 
                className="layout-logo-image"
              />
            </Link>
          </div>
          
          <nav className="layout-nav">
            <Link 
              to="/query" 
              className={`layout-nav-link neuro-silkafont-regular ${isActive('/query') ? 'active' : ''}`}
            >
              Ask Questions
            </Link>
          </nav>
          
          <div className="layout-header-right">
            <div className="layout-user">
              <div className="avatar avatar-primary">
                {user?.name?.charAt(0) || user?.username?.charAt(0) || 'U'}
              </div>
            </div>
            <button onClick={handleLogout} className="btn-secondary">
              Sign Out
            </button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className={`layout-main ${location.pathname === '/query' ? 'layout-main-query' : ''}`}>
        <div className="ds-page-container">
          {children}
        </div>
      </main>
    </div>
  );
};

export default Layout;
